"use client"
import React from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import UralityImage from "@/components/shared/UralityImage";
import "@/components/shared/ParentContentThumbnail.css";
import ProfileInfoView from "@/components/shared/ProfileInfoView";

const ParentContentThumbnail = ({
  url,
  imageId,
  title,
  subtitle,
  owner,
  description,
  additionalText,
  contributionUrl
}) => {
  // console.log("ParentContentThumbnail", url, imageId, title, subtitle, owner, description, contributionUrl);
  return (
    <div className="parent-content-thumbnail">
      {imageId && (
        <Ratio aspectRatio="16x9">
          <div>
            <UralityImage imageId={imageId} tag="Image" />
          </div>
        </Ratio>
      )}
      <div className="contents">
        {owner && (
          <ProfileInfoView
            profile={owner}
            thumbnail="sm"
            inline={true}
            target="_blank"
          />
        )}
        <div className="thumbnail-title-subtitle">
          <h3>{title}</h3>
          {subtitle && <h4>{subtitle}</h4>}
        </div>
        {description && (
          <div className="thumbnail-description">
            <p>
              {description.length > 255
                ? description.substring(0, 255) + ".."
                : description}
            </p>
          </div>
        )}
        {additionalText && (
          <div className="thumbnail-description">
            <p className="small">
              <i>{additionalText}</i>
            </p>
          </div>
        )}
        {contributionUrl && (
          <a
            className="with-icon"
            href={contributionUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="material-icons">add</span>
            <span>Contribute to this Map</span>
          </a>
        )}
      </div>
    </div>
  );
};
export default ParentContentThumbnail;
